/* Core & libraries */
import React, { useEffect } from "react";
import { useTheme } from "react-jss";

/* Helpers, constants, custom methods, internal libraries */
import { useAnalytics } from "../../hooks/useAnalytics";
import { AIRLINES, PAGE_TITLES } from "../../constants/appConstants";
import { lazyWithPreload, getLazyComponentWithSuspense } from "../../helpers/lazyLoadingHelpers";

/* Components */
export const HomeAA = lazyWithPreload(() => import('../../components/home/AA'));
export const HomeAS = lazyWithPreload(() => import('../../components/home/AS'));
export const HomeUC = lazyWithPreload(() => import('../../components/home/UC'));
export const HomeAC = lazyWithPreload(() => import('../../components/home/AC'));
export const HomeCHOICE = lazyWithPreload(() => import('../../components/home/CHOICE'));

/* Styles */
import styles from "./styles.js"
import {useUserContext} from "../../contexts/userContext";

const HOME_PAGE_BY_AIRLINE = {
  [AIRLINES.AA]: HomeAA,
  [AIRLINES.AS]: HomeAS,
  [AIRLINES.UC]: HomeUC,
  [AIRLINES.AC]: HomeAC,
  [AIRLINES.CHOICE]: HomeCHOICE,
};

const Home = () => {
  const theme = useTheme();
  const classes = styles({ theme });

  const userDetails = useUserContext();
  const airline = userDetails?.userInfo?.providerInfo?.providerCode;

  const { initAnalytics } = useAnalytics();

  useEffect(() => {
    (async () => {
      const initUtagData = {
        channel: 'content',
        pageName: PAGE_TITLES["home"]
      };
      initAnalytics(initUtagData, 'init call', 'view')
    })();
  }, []);

  const HomeComponent = HOME_PAGE_BY_AIRLINE[airline];
  return HomeComponent ? getLazyComponentWithSuspense(HomeComponent) : null;
}

export default Home;
